import styled from "@emotion/styled";
import { fontRoboto } from "@product/scmp-sdk";

import {
  Headline as ContentHeadline,
  SponsorHeadline,
} from "~/components/content/content-headline/styles";
import { EntityLink } from "~/components/entity-link";

export const Cover = styled.div``;
export const Overlay = styled.div`
  block-size: 100%;

  background-color: rgba(0, 0, 0, 0.5);

  ${props => props.theme.breakpoints.up("tablet")} {
    background-color: rgba(0, 0, 0, 0);
    background-image: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.8),
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0)
    );
  }
`;

export const Headline = styled.div`
  ${ContentHeadline}, ${SponsorHeadline} {
    display: -webkit-box;

    max-inline-size: 91%;
    max-block-size: 90px;
    margin: auto;

    color: #ffffff;
    font-weight: 900;
    font-size: 27px;
    font-family: ${fontRoboto};
    font-style: unset;
    line-height: 30px;
    text-align: center;
    text-overflow: ellipsis;

    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }
`;

export const StyledEntityLink = styled(EntityLink)`
  display: grid;
  grid:
    "content" min-content
    / 100%;
  justify-content: center;
  align-items: center;

  ${Cover}, ${Headline}, ${Overlay} {
    grid-area: content;
  }
`;

export const Container = styled.div``;
